import React, { useState } from 'react';
import useApi from '../CustomHooks/useApi';
import { useToast } from '../../Contexts/ToastContext';
import { subsidiesAPI } from '../../api/apiClient';
import "../../css/Subsidies/SubsidiesManager.css";
import ParticipantSubsidyDetails from './ParticipantSubsidyDetail';
import GrantSubsidyPopup from './GrantSubsidyPopup';
import Loading from "../../Loading";
import { useUser } from '../userContext';

const SubsidiesManager = () => {
  const [searchCode, setSearchCode] = useState('');
  const [reservation, setReservation] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const { callApi, isLoading } = useApi();
  const { callApi : grantSubsidyApi, isLoading : grantingSubsidy} = useApi();
  const { showToast, clearToast } = useToast();
  const { user} = useUser();
  const [isGranting, setIsGranting] = useState(false);

  const handleSearch = async () => {
    if (!searchCode) return;

    await callApi(
      () => subsidiesAPI.getRegistrationByCode(searchCode),
      (res) => {
        if (!res) {
          showToast("Nie znaleziono rezerwacji", "info");
          setReservation(null);
        } else {
          setReservation(res);
        }
      },
      clearToast
    );
  };

  const openPopup = (participant) => {
    setSelectedParticipant(participant);
  };

  const closePopup = () => {
    setSelectedParticipant(null);
  };

  const handleGrantSubsidy = async ({ subsidy, requestedAmount, percentage }) => {
    setIsGranting(true);
  
    await grantSubsidyApi(
      async () =>
        subsidiesAPI.grantSubsidy({
          participantGuid: selectedParticipant.guid,
          reservationGuid: reservation.reservationGuid,
          requestedAmount,
          percentage,
          subsidyAmount: subsidy,
        }),
      async () => {
        closePopup();
        await callApi(
          async () => subsidiesAPI.getRegistrationByCode(reservation.reservationCode),
          (res) => {
            setReservation(res);
            showToast("Dofinansowanie przyznane", "success");
            
          },
          clearToast
        );
      },
      clearToast
    );
    setIsGranting(false);
  };
  

  const statusMap = {
    1: { label: "Nieukończona", color: "#7f8c8d" },
    2: { label: "Lista rezerwowa", color: "#e16a00" },
    3: { label: "Potwierdzona", color: "#0d8732" },
    4: { label: "Oczekuje na zaliczkę", color: "#0081d7" },
    5: { label: "Anulowana", color: "#b91100" },
    6: { label: "Usunięta", color: "#363636" },
  };

  const formatDate = (iso) => {
    if (!iso) return "—";
    const date = new Date(iso);
    return date.toLocaleString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).replace(',', '');
  };

  return (
    <div className="subsidy-container">
      <div className="subsidy-container-title">Dofinansowania</div>

      <div className="subsidy-search">
        <input
          type="text"
          placeholder="Kod rejestracji"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value.toUpperCase())}
        />
        <div className="subsidy-button" onClick={handleSearch}>
          Szukaj
        </div>
      </div>

      {isLoading && <Loading />}

      {!isLoading && reservation && (
        <div className="subsidy-result">
          <div className="subsidy-header-box">
            <div className="subsidy-header-line">
              <span className="subsidy-header-label">Rezerwacja {searchCode}</span>
            </div>
            <div className="subsidy-header-line">
              <span className="subsidy-trip-name">{reservation.tripName}</span> –{" "}
              <span className="subsidy-variant-name">{reservation.variantName}</span>
            </div>
            <div className="subsidy-header-line subsidy-dates">
              <span>
                {formatDate(reservation.variantStartDate)} - {formatDate(reservation.variantEndDate)}
              </span>
            </div>
            <div className="subsidy-header-line">
            <span><strong>Koszt całkowity:</strong> {reservation.reservationCost.toFixed(2)} zł{" "}
              <span style={{ color: 'blue', fontWeight: 'bold' }}>
                ({reservation.reservationRealCost.toFixed(2)} zł)
              </span>
            </span>
          </div>
          <div className="subsidy-header-line">
            <span><strong>Zaliczka:</strong> {reservation.reservationPrepayment.toFixed(2)} zł{" "}
              <span style={{ color: 'blue', fontWeight: 'bold' }}>
                ({reservation.reservationRealPrepayment.toFixed(2)} zł)
              </span>
            </span>
          </div>

            <div className="subsidy-header-line">
              <span
                className="subsidy-status-label"
                style={{ backgroundColor: statusMap[reservation.reservationStatus]?.color }}
              >
                {statusMap[reservation.reservationStatus]?.label || "Nieznany status"}
              </span>
            </div>
          </div>

          <div className="subsidy-participants">
            <div className="subsidy-participant-title">Osoby uczestniczące:</div>
            {reservation.participants.map((p, index) => (
              <ParticipantSubsidyDetails
                key={index}
                participant={p}
                reservationStatus={reservation.reservationStatus}
                onEdit={() => openPopup(p)}
              />
            ))}
          </div>
        </div>
      )}

      {selectedParticipant && (
        <GrantSubsidyPopup
          participant={selectedParticipant}
          reservation={reservation}
          onClose={closePopup}
          onGrant={handleGrantSubsidy}
          isGranting={isGranting}
        />
      )}
    </div>
  );
};

export default SubsidiesManager;
